module.exports = __webpack_public_path__ + "static/media/vetcryo.82c945c3.png";